import IconCopy from 'images/account/copy.svg'

import cn from 'classnames'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'
import { CopyButtonWithSuccess } from 'components/ui/copy-button-with-success'

export default function Backup({ value, className }: { value: any; className?: string }) {
  const { t } = useTranslation()

  return (
    <div className={cn(styles.backup, className)}>
      <div className={styles.backup__title}>
        <span className={styles.backup__code}>{value}</span>
        <CopyButtonWithSuccess
          value={value}
          className={styles.iconBtn}
          successIconClassName={styles.iconSuccess}
          customIcon={IconCopy} />
      </div>
      <p className={styles.backup__subtitle}>
        {t('key_allows_recover_auth')}
      </p>
    </div>
  )
}
